import { inject, Injectable } from '@angular/core';
import { Action } from '@core/models/swagger';
import { PolicyActionEnum } from '@global/enums';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PolicyActionsFailure, PolicyActionsRequest, PolicyActionsSuccess } from './actions';
import { PolicyActionsService } from './service';

@Injectable()
export class PolicyActionsEffects {
  private readonly actions$ = inject(Actions);
  private readonly policyActionsService = inject(PolicyActionsService);

  policyActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PolicyActionsRequest),
      switchMap(({ parameters }) =>
        this.policyActionsService.actions(parameters).pipe(
          map(data => {
            const sortedActions: Action[] = [];
            // Cancellation, etc
            const noModifyPolicyActions = data.filter(a => a.actionId !== PolicyActionEnum.EDIT);
            // Change + Renewal
            const modifyPolicyAction = data.find(a => a.actionId === PolicyActionEnum.EDIT);
            const renewalAction: Action[] = [];

            if (modifyPolicyAction) {
              const renewalActionIndex = modifyPolicyAction.associatedActions?.findIndex(
                a => a.actionId === PolicyActionEnum.RENEW
              );
              if (modifyPolicyAction.associatedActions[renewalActionIndex]) {
                renewalAction.push(modifyPolicyAction.associatedActions[renewalActionIndex]);
              }
              // remove renewal action from the array
              modifyPolicyAction.associatedActions.splice(renewalActionIndex, 1);
              sortedActions.push(modifyPolicyAction, ...renewalAction);
            }
            sortedActions.push(...noModifyPolicyActions);
            return sortedActions;
          }),
          map(data => PolicyActionsSuccess({ data })),
          catchError(error => of(PolicyActionsFailure({ error })))
        )
      )
    )
  );

}
